import { useTranslation } from 'react-i18next';

interface StepDef {
  key: string;
  label: string;
}

interface StepIndicatorProps {
  steps: StepDef[];
  /** Índice (0-based) do passo atual. */
  current: number;
}

/** Barra de progresso com bolinhas numeradas e rótulos. */
export function StepIndicator({ steps, current }: StepIndicatorProps) {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('views.registration.progress_aria', 'Progresso do cadastro')} className="mb-[26px]">
      <ol className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isDone = index < current;
          const isActive = index === current;
          return (
            <li key={step.key} className="flex-1 flex flex-col items-center relative">
              {/* Linha conectora (à esquerda do círculo, exceto no primeiro) */}
              {index > 0 && (
                <span
                  aria-hidden="true"
                  className={`absolute top-[13px] right-1/2 w-full h-[2px] ${
                    index <= current ? 'bg-lime-500' : 'bg-mist-300'
                  }`}
                />
              )}
              <span
                className={`relative z-10 flex items-center justify-center w-[28px] h-[28px] rounded-full text-[12px] font-bold transition-colors ${
                  isDone
                    ? 'bg-lime-500 text-navy-900'
                    : isActive
                      ? 'bg-white text-navy-800 border-2 border-solid border-lime-500'
                      : 'bg-mist-100 text-mist-500 border border-solid border-mist-300'
                }`}
                aria-current={isActive ? 'step' : undefined}
              >
                {isDone ? <i className="fa fa-check" aria-hidden="true"></i> : index + 1}
              </span>
              <span
                className={`mt-[6px] text-[10px] text-center leading-tight hidden sm:block ${
                  isActive ? 'text-navy-800 font-semibold' : 'text-mist-500'
                }`}
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
